import React, { useState, useEffect, useCallback } from "react";
import { Select } from "antd";
import _ from "lodash";
import { fetchData } from "../../api/apiService";

const { Option } = Select;

// Map serviceType → FastAPI client list endpoint
const CLIENT_ENDPOINTS = {
  "income-tax": "/api/v1/clients/income-tax",
  gstin: "/api/v1/clients/gst",
  tds: "/api/v1/clients/tds",
};

const ClientAutoComplete = ({
  serviceType,
  handleSelect,
  value,
  className,
}) => {
  const [clientsData, setClientsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const debouncedSearchValue = _.debounce((value) => {
    getClientsData(value);
  }, 400);

  const getClientsData = useCallback(
    async (searchTerm = "") => {
      const endpoint = CLIENT_ENDPOINTS[serviceType];
      if (!endpoint) return;

      setLoading(true);
      try {
        const params = {
          page: 1,
          page_size: 50,
          only_disabled: false, // active clients only for dropdown
        };
        if (searchTerm) {
          params.client_name = searchTerm;
        }

        const data = await fetchData(endpoint, params);

        // FastAPI returns { items: [...], total, page, ... }
        // Map id → name for existing consumer code compatibility
        const items = (data?.items || []).map((c) => ({
          ...c,
          name: c.id,
        }));
        setClientsData(items);
      } catch (err) {
        console.error("Error fetching clients:", err);
        setClientsData([]);
      } finally {
        setLoading(false);
      }
    },
    [serviceType]
  );

  useEffect(() => {
    getClientsData();
  }, [getClientsData]);

  const handleSearch = (value) => {
    setSearchValue(value);
    debouncedSearchValue(value);
  };

  const handleChange = (selectedValue) => {
    if (handleSelect) {
      handleSelect(selectedValue);
    }
    setSearchValue("");
  };

  const handleClear = () => {
    if (handleSelect) {
      handleSelect(null);
    }
    setSearchValue("");
  };

  return (
    <div style={{ width: "100%", zIndex: 2147483647 }}>
      <Select
        className={className}
        style={{ width: "100%", height: "40px" }}
        value={value}
        onChange={handleChange}
        onSearch={handleSearch}
        onClear={handleClear}
        placeholder="Search and Filter Client Name"
        allowClear
        size="small"
        showSearch
        filterOption={false}
        loading={loading}
        notFoundContent={loading ? "Loading..." : "No clients found"}
        dropdownStyle={{ zIndex: 2147483647 }}
      >
        {clientsData.map((client) => (
          <Option
            key={client.name || client.client_name}
            value={client.client_name}
          >
            {client.client_name}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default ClientAutoComplete;
